import { axios } from "../../../lib/axios";

export const getServiceLinesByOrgId = (orgId, active = true) => {
  return axios.get(`organization/${orgId}/service-line?active=${active}`);
};

export const disableServiceLine = (serviceLineId, orgId, active = false) => {
  return axios.put(`organization/${orgId}/service-line/${serviceLineId}`, {
    active: active,
  });
};

export const enableServiceLine = (serviceLineId, orgId, active = true) => {
  return axios.put(`organization/${orgId}/service-line/${serviceLineId}`, {
    active: active,
  });
};

export const createServiceLine = (orgId, payload) => {
  return axios.post(`organization/${orgId}/service-line`, payload);
};

export const getServiceLineById = (orgId, serviceLineId) => {
  return axios.get(`organization/${orgId}/service-line/${serviceLineId}`);
};

export const getAvailableQuestionnaires = (
  orgId,
  purpose = "questionnaire",
  isDefault = true,
  getAllAuthorized
) => {
  return axios.get(`questionnaire?orgId=${orgId}&purpose=${purpose}&isDefault=${isDefault}&getAllAuthorized=true`);
};

export const getAvailableResources = (orgId, typeCode = "ref-doc") => {
  return axios.get(`documentreference?orgId=${orgId}&typeCode=${typeCode}`);
};

export const editServiceLine = (orgId, serviceLineId, payload) => {
  return axios.put(
    `organization/${orgId}/service-line/${serviceLineId}`,
    payload
  );
};
